import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Recommendation from './pages/Recommendation';
import Article from './pages/Article';
import SeoPage from './pages/SeoPage';
import CategoryPage from './pages/CategoryPage';
import NotFound from './pages/NotFound';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/recommendation/:mood" element={<Recommendation />} />
          <Route path="/articles/:slug" element={<Article />} />
          <Route path="/guides/:slug" element={<SeoPage />} />
          <Route path="/category/:slug" element={<CategoryPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
